import {CalculationNotificationServiceName} from "../utils/names/serviceNames";
import {CalculationsNotificationService} from "./service/CalculationsNotificationService";
import {OpportunityServiceModule} from "./opportunityServiceModuleConfiguration";

OpportunityServiceModule
    .createNewModule()
    .service(CalculationNotificationServiceName, CalculationsNotificationService.instance);